import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgEmissonsIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <g stroke="currentColor">
      <path
        strokeWidth={2.2}
        d="M24.884 23.047 9.28 31.5a.5.5 0 0 0-.244.575l8.116 28.74a.5.5 0 0 0 .612.346l8.069-2.188a.5.5 0 0 0 .362-.568L23.12 40.66a.5.5 0 0 1 .081-.369l5.762-8.377a.5.5 0 0 0 .049-.476l-3.429-8.146a.5.5 0 0 0-.699-.245Z"
      />
      <path
        strokeWidth={2}
        d="M20.519 14.147c.287-.134.78-.14 1.372.175.574.306 1.134.869 1.472 1.644.373.855.409 1.473.278 1.9-.12.397-.443.822-1.222 1.184-.77.358-1.178.279-1.448.123-.346-.2-.73-.672-1.132-1.595a3.35 3.35 0 0 1-.168-2.211c.188-.679.547-1.08.848-1.22Z"
      />
      <path
        strokeWidth={1.9}
        d="M15.167 18.1c.184-.086.554-.106 1.042.157.468.252.937.719 1.229 1.363.326.718.358 1.22.265 1.551-.083.295-.314.623-.932.91-.606.283-.905.208-1.097.096-.27-.157-.592-.54-.946-1.32a2.8 2.8 0 0 1-.177-1.815c.14-.556.418-.85.616-.942ZM10.288 21.37c.153-.07.477-.095.914.131.42.217.84.622 1.104 1.185.298.639.322 1.071.244 1.346-.07.243-.268.534-.834.797-.556.259-.811.185-.962.1-.226-.126-.515-.448-.842-1.15a2.4 2.4 0 0 1-.163-1.588c.125-.49.373-.743.54-.82Z"
      />
      <path
        strokeWidth={1.7}
        d="M5.846 24.52c.182-.085.504-.101.895.084.38.18.746.517.966.988.252.54.262.904.185 1.141-.073.223-.277.503-.832.761-.55.256-.807.193-.946.121-.194-.1-.444-.362-.726-.963a1.94 1.94 0 0 1-.102-1.358c.127-.43.367-.684.56-.774Z"
      />
      <path
        strokeWidth={2.2}
        d="m39.116 11.03 15.605 8.454a.5.5 0 0 1 .243.575l-8.116 28.74a.5.5 0 0 1-.612.347l-8.068-2.19a.5.5 0 0 1-.363-.567l3.075-17.745a.5.5 0 0 0-.081-.369l-5.762-8.377a.5.5 0 0 1-.049-.476l3.429-8.146a.5.5 0 0 1 .699-.245Z"
      />
      <path
        strokeWidth={2}
        d="M43.481 2.13c-.287-.133-.78-.14-1.372.176-.574.306-1.134.869-1.472 1.644-.373.855-.409 1.473-.278 1.9.12.397.443.822 1.222 1.184.77.358 1.177.279 1.448.123.346-.2.73-.672 1.132-1.595.33-.755.349-1.555.168-2.211-.188-.679-.547-1.08-.848-1.22Z"
      />
      <path
        strokeWidth={1.9}
        d="M48.833 6.084c-.184-.086-.554-.106-1.042.157-.468.253-.937.719-1.229 1.363-.326.719-.358 1.22-.265 1.551.083.295.314.623.932.91.606.283.905.208 1.097.096.27-.157.592-.54.946-1.32a2.8 2.8 0 0 0 .177-1.815c-.14-.556-.418-.85-.616-.942ZM53.712 9.354c-.153-.07-.477-.095-.914.131-.42.217-.84.622-1.104 1.185-.298.639-.322 1.071-.244 1.346.07.243.268.534.834.797.556.259.811.185.962.1.226-.126.515-.449.843-1.15.254-.544.281-1.12.162-1.588-.125-.49-.373-.743-.54-.82Z"
      />
      <path
        strokeWidth={1.7}
        d="M58.154 12.504c-.182-.085-.504-.101-.895.084-.38.18-.746.517-.965.988-.253.54-.263.904-.186 1.141.073.223.277.503.832.761.55.256.807.193.946.121.194-.1.444-.362.725-.963.212-.453.225-.945.103-1.358-.127-.43-.367-.684-.56-.774Z"
      />
    </g>
  </svg>
)
export default SvgEmissonsIcon
